var PickupPointField = (function (Backbone, Decoration, CheckoutApiModel, getPageTemplate) {

	var PickupPointField = CheckoutApiModel.extend({

		initialize: function (attrs, opts) {
			this.opts = _.extend({
				saveOnSelect: false
			}, opts);

			this.set({
				'Postcode': new Decoration(),
				'AddressID': null,
				'IsPickupPointsEnabled': false
			});

			this.get('Postcode').on('change:Value', this._onChangePostcode, this);
		},

		setAddressID: function (id) {
			this.set('AddressID', id);
			return this;
		},

		populatePostcode: function (props, opts) {
			var postcode = this.get('Postcode');

			// TBD: Using template here can be not true. I think we need another decoration from PAPI
			// or use some hardcoded values for forms in the view layer.
			_.extend(props, {
				Current: null,
				Name: 'PostcodePickup',
				Label: getPageTemplate('_PostcodePickupLabel')
			});

			postcode.set(props, opts);
			return this;
		},

		setPostcodeValue: function (value) {
			var postcode = this.get('Postcode');
			postcode.setValue(value);
			return this;
		},

		propagatePostcodeValue: function (value) {
			var postcode = this.get('Postcode');

			if (!postcode.isChangedByUser() && !this.getSelectedPickupPoint()) {
				this.setPostcodeValue(value);
			}
		},

		setSelectedPickupPointByAttrs: function (attrs, opts) {
			return this;
		},

		setIsEnabled: function (isEnabled) {
			this.set('IsPickupPointsEnabled', isEnabled);
			return this;
		},

		setSelectedPickupPoint: function (data) {
			this.set('Current', data);
			this.trigger('selected');
		},

		getSelectedPickupPoint: function () {
			return this.get('Current');
		},

		clear: function () {
			this.set('Current', null);
			this.get('Postcode').clearValue().clearChangedByUser();
			this.set('AddressID', null);
			this.trigger('clear');
			return this;
		},

		isValid: function () {
			var status = !!this.getSelectedPickupPoint();
			this.trigger('validation', status);
			return status;
		},

		isEnabled: function () {
			return this.get('IsPickupPointsEnabled') || false;
		},

		sync: function (method, model, options) {
			if (method === 'read') {
				if (options.postcode) {
					return this._syncReadByPostcode(model, options);
				} else {
					return this._syncReadByCoordinates(model, options);
				}
			}else if (method === 'update') {
				return this._syncUpdate(model, options);
			}

			throw new Error('PickupPointField model does not support "' + method + '" method.');
		},

		_syncReadByPostcode: function (model, options) {
			return this._api.getPickupPointsByPostcode(options.postcode ).done(function (data) {
				options.success && options.success(data.Value, null, this);
				model.trigger('syncByPostcode', data.Value, options);
			}).fail(function () {
				options.error && options.error(model, this, options);
				model.trigger('syncByPostcode', [], options);
			});
		},

		_syncReadByCoordinates: function (model, options) {
			var data = { lat: options.lat, lng: options.lng, radius: options.radius, count: options.count || null };
			return this._api.getPickupPointsByCoordinates(data).done(function (data) {
				options.success && options.success(data.Value, null, this);
				model.trigger('syncByCoordinates', data.Value, options);
			}).fail(function () {
				options.error && options.error(model, this, options);
				model.trigger('syncByCoordinates', [], options);
			});
		},

		_syncUpdate: function (model, options) {
			var addressID = this.get('AddressID'),
		        currentPickupPoint = this.getPickupPoints().getSelectedModel();

			return this._api.setAddressAdditionalData({
				additionalData: currentPickupPoint && JSON.stringify(currentPickupPoint),
				deliveryAddressID: addressID
			}).done(function (data) {
				options.success && options.success(data.Value, null, this);
				model.trigger('sync', model, data.Value, options);
			}).fail(function () {
				options.error && options.error(model, this, options);
				model.trigger('error', model, this, options);
			});
		},

		_onChangePostcode: function (decoration, postcode, opts) {
			if (opts && opts.noFetch || !postcode) {
				return;
			}
			decoration.isValid() && this.fetch({
				postcode: postcode
			});
		}
	});

	return PickupPointField;
})(Backbone, Decoration, CheckoutApiModel, kos.getPageTemplate);
